import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';

export const CategoryNavigation = ({ categories = [], currentCategory, startUrl, isOpenInEditorIframe = false }) => {
  return (
    <Container isOpenInEditorIframe={isOpenInEditorIframe}>
      <ul>
        {categories.map((category) => (
          <CategoryLink
            key={category.caption}
            isActive={currentCategory === category.slug}
            isMobile={deviceDetected.isMobile}>
            <Link href={category.slug === 'all' ? `${startUrl}` : `${startUrl}/${category.slug}`} passHref>
              <a aria-label={category.caption}>{category.caption}</a>
            </Link>
          </CategoryLink>
        ))}
      </ul>
    </Container>
  );
};

const Container = styled.nav`
  overflow: auto;
  white-space: ${(p) => (p.isOpenInEditorIframe ? 'wrap' : 'nowrap')};
  padding-bottom: 10px;
  margin-bottom: -10px;

  ul {
    ${Mixins.resetList()};
    text-align: center;
  }
`;

const CategoryLink = styled.li`
  ${Mixins.transition('color')};
  font-size: 16px;
  line-height: 110%;
  margin: 0 10px;
  display: inline-block;
  color: ${({ isActive }) => (isActive ? Colors.main_blue : Colors.main_dark)};

  &:first-child {
    margin-left: 0;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${Colors.second_blue};
    }
  }

  &:active {
    color: ${Colors.main_blue};
  }

  &:focus {
    all: unset;
    color: ${Colors.main_dark};
  }

  a {
    ${Mixins.resetLink()};
  }
`;
